/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpsertNftRewardBody
 */
export interface UpsertNftRewardBody {
    /**
     * 
     * @type {string}
     * @memberof UpsertNftRewardBody
     */
    nftTracker: string;
    /**
     * 
     * @type {string}
     * @memberof UpsertNftRewardBody
     */
    contractAbi: string;
    /**
     * 
     * @type {string}
     * @memberof UpsertNftRewardBody
     */
    image?: string;
    /**
     * 
     * @type {string}
     * @memberof UpsertNftRewardBody
     */
    origin?: string;
    /**
     * 
     * @type {string}
     * @memberof UpsertNftRewardBody
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof UpsertNftRewardBody
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof UpsertNftRewardBody
     */
    relayerUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof UpsertNftRewardBody
     */
    forwarderAddress?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpsertNftRewardBody
     */
    isEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpsertNftRewardBody
     */
    redemptionAnimation?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpsertNftRewardBody
     */
    transitionEffectEnabled?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpsertNftRewardBody
     */
    prizes: Array<string>;
}

/**
 * Check if a given object implements the UpsertNftRewardBody interface.
 */
export function instanceOfUpsertNftRewardBody(value: object): value is UpsertNftRewardBody {
    if (!('nftTracker' in value) || value['nftTracker'] === undefined) return false;
    if (!('contractAbi' in value) || value['contractAbi'] === undefined) return false;
    if (!('prizes' in value) || value['prizes'] === undefined) return false;
    return true;
}

export function UpsertNftRewardBodyFromJSON(json: any): UpsertNftRewardBody {
    return UpsertNftRewardBodyFromJSONTyped(json, false);
}

export function UpsertNftRewardBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpsertNftRewardBody {
    if (json == null) {
        return json;
    }
    return {
        
        'nftTracker': json['nftTracker'],
        'contractAbi': json['contractAbi'],
        'image': json['image'] == null ? undefined : json['image'],
        'origin': json['origin'] == null ? undefined : json['origin'],
        'title': json['title'] == null ? undefined : json['title'],
        'description': json['description'] == null ? undefined : json['description'],
        'relayerUrl': json['relayerUrl'] == null ? undefined : json['relayerUrl'],
        'forwarderAddress': json['forwarderAddress'] == null ? undefined : json['forwarderAddress'],
        'isEnabled': json['isEnabled'] == null ? undefined : json['isEnabled'],
        'redemptionAnimation': json['redemptionAnimation'] == null ? undefined : json['redemptionAnimation'],
        'transitionEffectEnabled': json['transitionEffectEnabled'] == null ? undefined : json['transitionEffectEnabled'],
        'prizes': json['prizes'],
    };
}

export function UpsertNftRewardBodyToJSON(json: any): UpsertNftRewardBody {
    return UpsertNftRewardBodyToJSONTyped(json, false);
}

export function UpsertNftRewardBodyToJSONTyped(value?: UpsertNftRewardBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'nftTracker': value['nftTracker'],
        'contractAbi': value['contractAbi'],
        'image': value['image'],
        'origin': value['origin'],
        'title': value['title'],
        'description': value['description'],
        'relayerUrl': value['relayerUrl'],
        'forwarderAddress': value['forwarderAddress'],
        'isEnabled': value['isEnabled'],
        'redemptionAnimation': value['redemptionAnimation'],
        'transitionEffectEnabled': value['transitionEffectEnabled'],
        'prizes': value['prizes'],
    };
}

